import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { BiXCircle } from "react-icons/bi";
import { ROUTES } from "../../../helpers/constants";
import { PAYMENT_STRINGS } from "./strings";
import ClientAPI from "../../../services/api/clients.api";
import { ButtonLoading } from "../../../components/buttons/button-loading";

const strings = PAYMENT_STRINGS.failure;

const PaymentFailure = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const clientId = searchParams.get("clientId");

  const [retrying, setRetrying] = useState(false);

  const handleBack = () => {
    if (clientId) {
      navigate(`${ROUTES.CLIENTS.route}/${clientId}`);
    } else {
      navigate(ROUTES.CLIENTS.route);
    }
  };

  const handleRetry = async () => {
    setRetrying(true);
    try {
      const res = await ClientAPI.findClient(clientId);
      navigate(ROUTES.PURCHASE.route, { state: { client: res.data } });
    } catch {
      handleBack();
    }
  };

  return (
    <div className="gm-clients-details-container">
      <div className="gm-folder-container" style={{ marginTop: 40, display: "flex", flexDirection: "column", alignItems: "center" }}>
        <BiXCircle size={56} color="#d32f2f" style={{ marginBottom: 16 }} />
        <h2 style={{ fontWeight: 500, fontSize: 22, marginBottom: 0 }}>{strings.title}</h2>
        <p style={{ color: "#666", marginTop: 12, marginBottom: 32 }}>
          {strings.description}
        </p>
        <div style={{ display: "flex", gap: 16 }}>
          <button
            type="button"
            className="gm-outline-button"
            style={{ padding: "10px 16px" }}
            onClick={handleBack}
          >
            {strings.backButton}
          </button>
          {clientId && (
            <ButtonLoading
              type="button"
              className="gm-primary-button"
              style={{ padding: "10px 16px", width: 180, opacity: retrying ? 0.6 : 1, pointerEvents: retrying ? "none" : "auto" }}
              onClick={handleRetry}
              loading={retrying}
              buttonLabel={retrying ? "" : strings.retryButton}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default PaymentFailure;
